/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CardCheckoutPaymentMethodDto } from './CardCheckoutPaymentMethodDto';
import {
    CardCheckoutPaymentMethodDtoFromJSON,
    CardCheckoutPaymentMethodDtoFromJSONTyped,
    CardCheckoutPaymentMethodDtoToJSON,
    CardCheckoutPaymentMethodDtoToJSONTyped,
} from './CardCheckoutPaymentMethodDto';
import type { BrowserInfoDto } from './BrowserInfoDto';
import {
    BrowserInfoDtoFromJSON,
    BrowserInfoDtoFromJSONTyped,
    BrowserInfoDtoToJSON,
    BrowserInfoDtoToJSONTyped,
} from './BrowserInfoDto';
import type { AuthorisePaymentTestOptions } from './AuthorisePaymentTestOptions';
import {
    AuthorisePaymentTestOptionsFromJSON,
    AuthorisePaymentTestOptionsFromJSONTyped,
    AuthorisePaymentTestOptionsToJSON,
    AuthorisePaymentTestOptionsToJSONTyped,
} from './AuthorisePaymentTestOptions';

/**
 * 
 * @export
 * @interface AuthorisePaymentRequest
 */
export interface AuthorisePaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthorisePaymentRequest
     */
    origin: string;
    /**
     * 
     * @type {CardCheckoutPaymentMethodDto}
     * @memberof AuthorisePaymentRequest
     */
    paymentMethod: CardCheckoutPaymentMethodDto;
    /**
     * 
     * @type {BrowserInfoDto}
     * @memberof AuthorisePaymentRequest
     */
    browserInfo?: BrowserInfoDto | null;
    /**
     * 
     * @type {AuthorisePaymentTestOptions}
     * @memberof AuthorisePaymentRequest
     */
    testOptions?: AuthorisePaymentTestOptions | null;
}

/**
 * Check if a given object implements the AuthorisePaymentRequest interface.
 */
export function instanceOfAuthorisePaymentRequest(value: object): value is AuthorisePaymentRequest {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    return true;
}

export function AuthorisePaymentRequestFromJSON(json: any): AuthorisePaymentRequest {
    return AuthorisePaymentRequestFromJSONTyped(json, false);
}

export function AuthorisePaymentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorisePaymentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'],
        'paymentMethod': CardCheckoutPaymentMethodDtoFromJSON(json['paymentMethod']),
        'browserInfo': json['browserInfo'] === undefined ? undefined : json['browserInfo'] === null ? null : BrowserInfoDtoFromJSON(json['browserInfo']),
        'testOptions': json['testOptions'] === undefined ? undefined : json['testOptions'] === null ? null : AuthorisePaymentTestOptionsFromJSON(json['testOptions']),
    };
}

export function AuthorisePaymentRequestToJSON(json: any): AuthorisePaymentRequest {
    return AuthorisePaymentRequestToJSONTyped(json, false);
}

export function AuthorisePaymentRequestToJSONTyped(value?: AuthorisePaymentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'paymentMethod': CardCheckoutPaymentMethodDtoToJSON(value['paymentMethod']),
        'browserInfo': BrowserInfoDtoToJSON(value['browserInfo']),
        'testOptions': AuthorisePaymentTestOptionsToJSON(value['testOptions']),
    };
}

